export default "__VITE_ASSET__DvPY1WRK__"